import {Observable, Subject} from "rxjs";
import {InjectionToken} from '@angular/core';

export interface NotificationClickHandler {
  handleClick(id: string): void;
  listener: () => Observable<string>;
}

export const NOTIFICATION_CLICK_HANDLER_TOKEN = new InjectionToken<NotificationClickHandler>('NotificationClickHandler');

export const provideNotificationClickHandler = {
  provide: NOTIFICATION_CLICK_HANDLER_TOKEN,
  useFactory: (): NotificationClickHandler => {
    const idSubject = new Subject<string>();
    return {
      handleClick: (id: string) => idSubject.next(id),
      listener: () => idSubject.asObservable()
    }
  }
}
